module.exports = __webpack_public_path__ + "img/venus27.7c99b716.png";